<template>
  <CustomerContactCard class="w-full" :contact="(content as ContactCardRestAPI).fields || content">
    <template #image>
      <ContentfulImage
        v-if="(content as ContactCardRestAPI)?.fields?.image || (content as ContactCard)?.image"
        :entry="(content as ContactCardRestAPI)?.fields?.image || (content as ContactCard)?.image"
        fit="fill"
        :width="100"
        :height="128"
      />
    </template>
  </CustomerContactCard>
</template>

<script setup lang="ts">
import type { ContactCardRestAPI, ContactCard } from '@/types/contentful';

type Props = {
  content: ContactCardRestAPI | ContactCard;
};

defineProps<Props>();
</script>

<script lang="ts">
export default defineComponent({
  name: 'ContactCard',
});
</script>
